export enum EPaymentMethod {
  ADYEN = 'adyen',
  PAYPAL = 'paypal',
}
